import { LogOut, PanelLeftClose, PanelLeftOpen } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { LogoLettersBlack, BunnyEarsLogo } from "../../../assets/images";
import { logoutFirebase } from "../../../auth/operations";
import { HOME } from "../../../utils/routes";
import {
  Aside,
  Backdrop,
  LogoRow,
  LogoImg,
  LogoMark,
  CollapseButton,
  NavList,
  NavItem,
  ItemLabel,
  Footer,
  LogoutButton,
} from "../../../components/PartnerDashboard/PartnerSidebar/styles";
import { ADMIN_SECTIONS, AdminSectionKey } from "./sections";

interface AdminSidebarProps {
  active: AdminSectionKey;
  onSelect: (key: AdminSectionKey) => void;
  open: boolean;
  onClose: () => void;
  collapsed: boolean;
  onToggleCollapsed: () => void;
}

const AdminSidebar = ({ active, onSelect, open, onClose, collapsed, onToggleCollapsed }: AdminSidebarProps) => {
  const navigate = useNavigate();

  const handleSelect = (key: AdminSectionKey) => {
    onSelect(key);
    onClose();
  };

  const handleLogout = async () => {
    await logoutFirebase();
    navigate(HOME);
  };

  return (
    <>
      <Backdrop $open={open} onClick={onClose} />
      <Aside $open={open} $collapsed={collapsed} aria-label="Admin dashboard navigation">
        <LogoRow $collapsed={collapsed}>
          {collapsed ? (
            <LogoMark src={BunnyEarsLogo} alt="JackedRabbit" />
          ) : (
            <LogoImg src={LogoLettersBlack} alt="JackedRabbit" />
          )}
          <CollapseButton
            onClick={onToggleCollapsed}
            aria-label={collapsed ? "Expand menu" : "Collapse menu"}
            title={collapsed ? "Expand menu" : "Collapse menu"}
          >
            {collapsed ? <PanelLeftOpen size={18} /> : <PanelLeftClose size={18} />}
          </CollapseButton>
        </LogoRow>

        <NavList>
          {ADMIN_SECTIONS.map((s) => {
            const Icon = s.icon;
            return (
              <NavItem
                key={s.key}
                $active={active === s.key}
                $collapsed={collapsed}
                onClick={() => handleSelect(s.key)}
                aria-current={active === s.key ? "page" : undefined}
                aria-label={collapsed ? s.label : undefined}
                title={collapsed ? s.label : undefined}
              >
                <Icon size={18} strokeWidth={active === s.key ? 2.4 : 2} />
                <ItemLabel $collapsed={collapsed}>{s.label}</ItemLabel>
              </NavItem>
            );
          })}
        </NavList>

        <Footer>
          <LogoutButton
            $collapsed={collapsed}
            onClick={handleLogout}
            aria-label={collapsed ? "Log out" : undefined}
            title={collapsed ? "Log out" : undefined}
          >
            <LogOut size={16} />
            <ItemLabel $collapsed={collapsed}>Log out</ItemLabel>
          </LogoutButton>
        </Footer>
      </Aside>
    </>
  );
};

export default AdminSidebar;
